export const PHONE_DISPLAY = "469-897-6497";
export const PHONE_TEL = "tel:+14698976497";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1594915440248-1e419eba6611?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  physical: "https://images.pexels.com/photos/13378812/pexels-photo-13378812.jpeg?auto=compress&cs=tinysrgb&w=1200",
  digital: "https://images.unsplash.com/photo-1774901128215-3549cc686921?q=85&w=1200&auto=format&fit=crop",
  cat6: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?q=85&w=1200&auto=format&fit=crop",
  av: "https://images.unsplash.com/photo-1586024486164-ce9b3d87e09f?q=85&w=1200&auto=format&fit=crop",
  ai: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=85&w=1200&auto=format&fit=crop",
};

export const SERVICE_OPTIONS = [
  "Low Voltage & TV / Audio Mounting",
  "Cabling, Fiber Optics & Networking",
  "Security Cameras & Smart Home",
  "Website & Digital Infrastructure",
  "AI Chatbots & Automation",
  "Other / Multiple Services",
];

export const HexMark = ({ className = "w-8 h-8 text-[#d4af37]" }) => (
  <svg className={className} viewBox="0 0 36 36" fill="none" aria-hidden="true">
    <polygon points="18 2, 32 10, 32 26, 18 34, 4 26, 4 10" stroke="#d4af37" strokeWidth="2" fill="none" />
    <text x="18" y="22" fontSize="12" fontWeight="900" fill="#d4af37" textAnchor="middle" fontFamily="sans-serif">28</text>
  </svg>
);
